import React from 'react';
import PropTypes from 'prop-types';
import SmartIconButton from '../SmartIconButton';

const RecorderControls = ({
  recorderState,
  startRecording,
  saveRecording,
  cancelRecording,
}) => {
  const { recordingMinutes, recordingSeconds, initRecording } = recorderState;

  const formatMinutes = (minutes) => {
    return minutes < 10 ? `0${minutes}` : minutes;
  };

  const formatSeconds = (seconds) => {
    return seconds < 10 ? `0${seconds}` : seconds;
  };

  return (
    <div
      className={`recorder-controls-wrapper controls-container ${
        initRecording && 'open'
      }`}
    >
      {initRecording && (
        <div className="recorder-display">
          <div className="cancel-button-container">
            <SmartIconButton onClick={cancelRecording} iconPath="mdiDelete" />
          </div>
          <div className="recording-time">
            {initRecording && <div className="recording-indicator" />}
            <span>{formatMinutes(recordingMinutes)}</span>
            <span>:</span>
            <span>{formatSeconds(recordingSeconds)}</span>
          </div>
        </div>
      )}

      <div className="start-button-container">
        {initRecording ? (
          <SmartIconButton
            disabled={!recordingSeconds}
            onClick={saveRecording}
            iconPath="mdiSend"
          />
        ) : (
          <SmartIconButton
            onClick={startRecording}
            iconPath="mdiMicrophoneOutline"
          />
        )}
      </div>
    </div>
  );
};

RecorderControls.propTypes = {
  recorderState: PropTypes.shape({
    recordingMinutes: PropTypes.number,
    recordingSeconds: PropTypes.number,
    initRecording: PropTypes.bool,
  }).isRequired,
  startRecording: PropTypes.func.isRequired,
  saveRecording: PropTypes.func.isRequired,
  cancelRecording: PropTypes.func.isRequired,
};

export default RecorderControls;
